(() => {
  /* Directives */

  var adtDirectives = angular.module('adtDirectives', []);

  adtDirectives.directive('includeReplace', () => ({
    require: 'ngInclude',
    restrict: 'A',
    link: (scope, el) => {
      el.replaceWith(el.children());
    }
  }));

  /*
   * Renders the loading animation. By default, the animation is placed in the middle of the parent container.
   * Needs the spin.js library
   */
  adtDirectives.directive('ajaxLoader', () => ({
    restrict: "A",
    link: (scope, elem) => {
      var opts = {
        lines: 11,
        length: 0,
        width: 3,
        radius: 7,
        trail: 38,
        speed: 2.2,
        top: '50%', // Top position relative to parent
        left: '50%' // Left position relative to parent
      };
      new Spinner(opts).spin(elem[0]);
    }
  }));

  /*
   * Automatically selects the text in the given input element on load
   */
  adtDirectives.directive('autoSelect', ['$timeout', function ($timeout) {
      return {
          restrict: 'A',
          link: function (scope, element) {
              $timeout(function () {
                  element.select();
              }, 500);
          }
      }
  }]);

  /*
   * Selects the text in the given element on click
   */
  adtDirectives.directive('clickSelect', function () {
      return {
          restrict: 'A',
          link: function (scope, element) {

              element.click(function () {
                  element.selectText();
              });
          }
      }
  });


  /*
   * Hides / shows the labels popover in the list campaigns page
   */
  adtDirectives.directive('popover', function () {
      return {
          restrict: 'A',
          link: function (scope, element) {
              var $popover = element.next();

              element.click(function () {
                $popover.hasClass('in') ? hide($popover, element) : show($popover, element);
              });

              function show(popover, marker) {
                // before hide all showed
                $('.popover').each(function () {
                  if ($(this).hasClass('in')) {
                    hide($(this), $(this).prev());
                  }
                });

                  var $pos = marker.position();
                  popover.css({
                      'top': $pos.top + marker.outerHeight() / 2 - popover.outerHeight(true) / 2,
                      'left': $pos.left + marker.outerWidth(),
                      'display': 'block'
                  }).addClass('in');

                  marker.closest('td').addClass('active');
              }

              function hide(popover, marker) {
                  popover.removeClass('in').css({
                      display: 'none'
                  });
                  marker.closest('td').removeClass('active');
              }

              $('#page-list')
                  .on('click', function () {
                      var $p = $('.popover');
                      $p.each(function () {
                          hide($(this), $(this).prev());
                      })
                  })
                  .on('click', '.popover, .popover-label', function (e) {
                      e.stopPropagation();
                  })
                  .on('click', '.popover-close', function () {
                      var $p = $(this).parents('.popover');
                      hide($p, $p.prev());
                  });
          }
      };
  });

  /*
   * slider
   */
  adtDirectives.directive('customSlider', function () {
      return {
          restrict: 'A',
          scope: {
              model: '=model'
          },
          link: function (scope, ele, attr) {
              var range = scope.$eval(attr.customSlider),
                  margin = scope.$eval(attr.sliderMargin),
                  value = attr.value;
              ele.noUiSlider({
                  range: range,
                  start: range,
                  curStep: 1,
                  margin: margin,
                  slide: function () {
                      var v = ele.val();
                      scope.$apply(function () {
                          scope.model = value === 'range' ? v : _.range(v[0], v[1] + 1);
                      });
                  }
              });

              scope.$watch('model', function (newV) {
                  if (newV) {
                      ele.val([newV[0], newV[newV.length - 1]]);
                  }
              })
          }
      }
  });

  /*
   * Enables scrolling
   */
  adtDirectives.directive('jsScroll', function () {

      $('.init-scroll-pane[js-scroll]').on('shown', function () {
          $('.scroll-pane', this).each(function () {
              !$(this).data('jsp') && $(this).jScrollPane();
          });
      });

      return function (scope, ele, attr) {
          scope.$on('success', function (event, msg) {
              ele.find('#rilist').each(function () {
                  var sp = $(this),
                      m = sp.data('model'),
                      ul = sp.find('ul');
                  var jsp = sp.data('jsp');
                  if (jsp) {
                      setTimeout(function () {
                          //console.log('reinitialise, height:'+ul.height());
                          //console.log('length:'+ul.children().length);
                          sp.find('.jspContainer').height(ul.height() + 31);
                          jsp.reinitialise();
                      }, 500);
                  }
              });

          });

          ele.find('.scroll-pane').each(function () {
              var sp = $(this),
                  m = sp.data('model'),
                  ul = sp.find('ul');

              if (m) {
                  scope.$watch(m, reinit);
              } else {
                  scope.$watch(function () {
                      return ul.children().length;
                  }, reinit)
              }

              function reinit() {
                  var jsp = sp.data('jsp');
                  if (jsp) {
                      setTimeout(function () {
                          //console.log('reinitialise, height:'+ul.height());
                          //console.log('length:'+ul.children().length);
                          sp.find('.jspContainer').height(ul.height() + 31);
                          jsp.reinitialise();
                      }, 500);
                  }
              }
          });
      }
  });

  /*
   * Enables copy pasting of multiple report items in the add report items modal
   */
  adtDirectives.directive('pasteAdd', function () {
      return {
          link: function (scope, ele) {
              ele.on('paste', function () {
                  setTimeout(function () {
                      // Simulate enter key pressed IF multiple lines were pasted
                      var pastedText = ele.val();
                      if (/\r|\n/.exec(pastedText)) {
                          scope.addModal.processInput($.Event("keydown", {
                              keyCode: 13
                          }));
                      }
                      scope.$digest();
                  }, 100);
              })
          }
      }
  });

  adtDirectives.directive('contenteditable', function () {
      return {
          require: 'ngModel',
          link: function (scope, elm, attrs, ctrl) {
              // view -> model
              elm.bind('blur', function () {
                  scope.$apply(function () {
                      ctrl.$setViewValue(elm.text());
                  });
              });
              elm.bind('keypress', function (e) {
                  if (e.charCode === 13) {
                      e.preventDefault();
                      this.blur(); // Triggers view update
                  }
              });
              // We attach the view update to the 'keyup' event so the element value will contain the last typed character
              elm.bind('keyup', function (e) {
                  var nonInputKeyCodes = [13,16,17,18,20,35,36,37,38,39,40];
                  if ( ! _.contains(nonInputKeyCodes, e.charCode)) {
                      scope.$apply(function () {
                          ctrl.$setViewValue(elm.text());
                      });
                  }
              });

              // model -> view
              ctrl.$render = function () {
                  elm.text(ctrl.$viewValue);
              };
          }
      };
  });

  adtDirectives.directive('editableList', function () {
      return function (scope, ele, attrs, ctrl) {
          ele.on('keydown', 'li', function (e) {
              var keyCode = e.keyCode || e.which,
                  arrow = {
                      left: 37,
                      up: 38,
                      right: 39,
                      down: 40
                  };
              //up key
              switch (keyCode) {
              case arrow.up:
                  $(this).prev().find('.text').focus();
                  break;
              case arrow.down:
                  $(this).next().find('.text').focus();
                  break;
              }
          })
      }
  });

  /*
   * Used in report controller
   */
  adtDirectives.directive('customPopover', function () {
      return function (scope, ele, attr) {
          $('#page-report')
              .on('click', function () {
                  var $p = $('.popover');
                  $p.each(function () {
                      $(this).prev().removeClass('primary').addClass('dark');
                      $(this).parent().removeClass('active');
                  })
              })
              .on('click', '.popover, .po-custom-trigger', function (e) {
                  e.stopPropagation();
              });

          ele.click(function () {
              var t = $(this);
              var i = t.find('> .icon');

              if (t.is('.active')) {
                  i.removeClass('primary').addClass('dark');
              } else {
                  $(".po-custom-trigger.active")
                      .removeClass("active")
                      .find("> .icon")
                      .removeClass('primary')
                      .addClass('dark');

                  i.removeClass('dark').addClass('primary');
              }

              t.toggleClass('active');
          });
      }
  });

  adtDirectives.directive('tooltip', () => (scope, ele, attr) => {
    const position = attr.position || 'bottom';
    const mobileOnly = attr.tooltip;
    if (!mobileOnly || (mobileOnly && $(window).width() < 1200)) {
      ele.tooltip({
        delay: {
          show: 700,
          hide: 0
        },
        placement: position,
        trigger: 'hover',
        animation: false,
        html: true
      });
    }
  });

  adtDirectives.directive('affinityprofilechart', () => {
    return {
      scope: {
        affinitydata: '=affinitydata',
      },
      link: (scope, elem, attrs) => {
        scope.$watch('affinitydata', affinitydata => {
          if (affinitydata) {
            const values = scope.affinitydata;
            if (_.size(values) > 0) {
              let maxValue = 0;
              angular.forEach(values, (categoryValues, category) => {
                angular.forEach(categoryValues, (value, categoryValue) => {
                  if (value > maxValue) {
                    maxValue = value;
                  }
                });
              });

              const widthValue = (100 / maxValue) * 100;
              const widthBar = widthValue > 100 ? 100 : widthValue;
              elem.find('.marker, .pa-graph-bar').width(`${widthBar}%`);

              const drawBars = () => {
                angular.forEach(values, (categoryValues, category) => {
                  if (category.substr(0, 1) == '$' || category === 'name') return;

                  angular.forEach(categoryValues, (value, categoryValue) => {
                    // values is a promise so it will contain keys like '$then' - we skip those
                    if (categoryValue.substr(0, 1) == '$') return;

                    const w = ((value / maxValue) * 100) + '%';
                    const label = category + categoryValue[0].toUpperCase() + categoryValue.slice(1);
                    const e = elem.find('.col[data-label=' + label + ']');
                    e.find('.pa-graph-bar').width(w);
                    e.find('.value').html(Math.round(value));
                  });
                });
              };

              // In the PDF export, skip the animations
              if (document.querySelector('body.pdf-export') != null) {
                elem.addClass('show');
                drawBars();
              } else {
                setTimeout(() => {
                  elem.addClass('show');
                }, 200);

                setTimeout(() => {
                  elem.addClass('animate');
                  drawBars();
                }, 1000);
              }

            } //logic ends
          }
        }, true);
      }
    };
  });

})();
